import { Column, Entity, PrimaryColumn } from 'typeorm';

import { ImagePath, IndividualReportTemplate } from './report-preview/report-template';

/**
 * IndividualReportTemplateSchema インターフェイス。
 */
export interface IIndividualReportTemplateSchema {
  id: string;
  name: string;
  subjectModelIds: string;
  schemaVersion: string;
  template: string;
  isValid: boolean;
  reportTitleInputMode: string;
  reportTitleFormat: string;
  createdBy: string;
  createDate: string;
  lastUpdatedBy: string;
  lastUpdateDate: string;
  tenantId: string;
  imagePathList: string;
  isDeleted: boolean;
  /** オフラインで作成したかどうか。 */
  isOfflineData: boolean;
}

@Entity()
export class IndividualReportTemplateSchema implements IIndividualReportTemplateSchema {
  @PrimaryColumn()
    id: string;

  @Column({ nullable: true })
    name: string | null;

  @Column({ nullable: true })
    subjectModelIds: string | null;

  @Column({ nullable: true })
    schemaVersion: string | null;

  @Column({ nullable: true })
    template: string | null;

  @Column({ nullable: true })
    isValid: boolean | null;

  @Column({ nullable: true })
    reportTitleInputMode: string | null;

  @Column({ nullable: true })
    reportTitleFormat: string | null;

  @Column({ nullable: true })
    createdBy: string | null;

  @Column({ nullable: true })
    createDate: string | null;

  @Column({ nullable: true })
    lastUpdatedBy: string | null;

  @Column({ nullable: true })
    lastUpdateDate: string | null;

  @Column({ nullable: true })
    tenantId: string | null;

  @Column({ nullable: true })
    imagePathList: string | null;

  @Column({ nullable: true })
    isDeleted: boolean | null;

  @Column({ nullable: true })
    isOfflineData: boolean | null;

  constructor(reportTemplate?: IndividualReportTemplate, tenantId?: string) {
    if (reportTemplate) {
      this.id = reportTemplate.id;
      this.name = reportTemplate.name;
      this.subjectModelIds = JSON.stringify(reportTemplate.subjectModelIds);
      this.schemaVersion = reportTemplate.schemaVersion;
      this.template = JSON.stringify(reportTemplate.template);
      this.isValid = reportTemplate.isValid;
      this.reportTitleInputMode = reportTemplate.reportTitleInputMode;
      this.reportTitleFormat = JSON.stringify(reportTemplate.reportTitleFormat);
      this.createdBy = reportTemplate.createdBy;
      this.createDate = reportTemplate.createDate;
      this.lastUpdatedBy = reportTemplate.lastUpdatedBy;
      this.lastUpdateDate = reportTemplate.lastUpdateDate;
      this.imagePathList = JSON.stringify(this.parseImagePaths(reportTemplate.imagePathList));
      this.isDeleted = false;
      this.isOfflineData = reportTemplate.isOfflineData;
    }

    if (tenantId) {
      this.tenantId = tenantId;
    }
  }

  parseImagePaths(imagePathList: ImagePath[]) {
    return imagePathList.map(_ => {
      const term = 'reportTemplates';
      const fileName = this.getFileNameFromSAS(_.src, term);
      const obj = new ImagePath();
      obj.id = fileName;
      obj.src = this.extractPathFromSAS(_.src, term);
      return obj;
    });
  }

  private extractPathFromSAS(sasUrl: string, term: string) {
    if (!sasUrl) {
      return '';
    }

    const indexOfTerm = sasUrl.indexOf(term);
    const temp = indexOfTerm > 0
      ? sasUrl.slice(indexOfTerm)
      : sasUrl;

    // '?'より後ろを削除
    const indexOfQ = temp.indexOf('?');
    const result = indexOfQ > 0
      ? temp.slice(0, indexOfQ)
      : temp;

    return decodeURIComponent(result);
  }

  private getFileNameFromSAS(sasUrl: string, term: string) {
    const path = this.extractPathFromSAS(sasUrl, term);
    const parts = path.split('\\');
    const fileName = parts[parts.length - 1];
    return fileName.split('/').pop();
  }
}
